/*
 * @Description: 用户api
 * @Autor: WangYuan
 * @Date: 2021-09-22 16:22:01
 * @LastEditors: Yehon He 1427749162@qq.com
 * @LastEditTime: 2025-01-05 21:33:38
 */

import request from '@/utils/request'

/**
 * 登录
 */
export const login = async (data) => request({ url: "/login", method: "POST", data })

/**
 * 注册
 */
export const register = async (data) => request({ url: "/register", method: "POST", data })

/**
 * 用户列表
 */
export const getUserList = async data => request({url: '/usersManage', method: 'GET', params:data})
export const getUserView = async data => request({url: '/usersManageView', method: 'GET', params:data})
export const getUserPut = async data => request({url: '/usersManageView', method: 'PUT', data})


